import fetchClient from "common/functions/fetcher";
import { MainContextContainer } from "components/Main";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Licenses } from "./interfaces";

export const useLicenseHooks = () => {
  const initRef = useRef(true);

  const mainContext = useContext(MainContextContainer);

  const [licenses, setLicenses] = useState<Licenses>({});

  const onLoaded: () => void = useCallback(async () => {
    const responseProd = await fetchClient
      .get<Licenses>(`${process.env.PUBLIC_URL}/licenses_prod.json`)
      .catch(() => undefined);

    const responseDev = await fetchClient
      .get<Licenses>(`${process.env.PUBLIC_URL}/licenses_dev.json`)
      .catch(() => undefined);

    const data = {
      ...(responseProd?.data || {}),
      ...(responseDev?.data || {})
    };

    if (data) {
      setLicenses(data);
    }
  }, []);

  useEffect(() => {
    if (initRef.current) {
      initRef.current = false;
      onLoaded();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    mainContext,
    licenses
  } as const;
};
